/* CPM — adicionar ao carrinho sem sair da página
 *
 * O PROBLEMA QUE ISTO RESOLVE:
 * A PDP da loja (sections/cpm-pdp.liquid) monta um <form action="/cart/add">
 * puro, SEM envolver no <product-form> do Dawn — e o product-form.js nem
 * chega a ser carregado na página de produto. Sem isso, o clique em
 * "Adicionar ao carrinho" é um submit nativo: POST de página inteira, e o
 * navegador para em /cart. A gaveta do Dawn nunca abre.
 *
 * Este arquivo intercepta o submit de qualquer formulário que aponte para
 * /cart/add, adiciona por fetch e abre a gaveta — exatamente o que o
 * <product-form> do Dawn faria. Formulários que JÁ estejam dentro de um
 * <product-form> são ignorados, para não duplicar o item.
 *
 * Quando o cpm-pdp for reescrito usando <product-form>, este arquivo e a
 * seção cpm-cart-ajax podem ser removidos.
 */
(function () {
  function gaveta() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function aoEnviar(evento) {
    var form = evento.target;
    if (!form || form.tagName !== 'FORM') return;

    var acao = form.getAttribute('action') || '';
    if (acao.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;

    var cart = gaveta();
    if (!cart || typeof cart.renderContents !== 'function') return;

    evento.preventDefault();

    var botao = form.querySelector('[type="submit"]') || form.querySelector('.pdp__cta');
    if (botao) {
      botao.setAttribute('aria-disabled', 'true');
      botao.classList.add('loading');
    }
    function liberar() {
      if (botao) {
        botao.removeAttribute('aria-disabled');
        botao.classList.remove('loading');
      }
    }

    var dados = new FormData(form);
    try {
      dados.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      dados.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    } catch (e) {}

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: dados
    })
      .then(function (r) { return r.json(); })
      .then(function (resposta) {
        if (resposta.status) {
          console.warn('[CPM] carrinho recusou o item:', resposta.description || resposta.message);
          liberar();
          return;
        }
        cart.renderContents(resposta);
        cart.classList.remove('is-empty');
        if (typeof cart.open === 'function') cart.open(botao);
        liberar();
      })
      .catch(function (erro) {
        console.error('[CPM] falha ao adicionar por fetch, caindo no envio normal:', erro);
        liberar();
        form.submit();
      });
  }

  document.addEventListener('submit', aoEnviar, true);
})();
